"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Tracking = _interopRequireDefault(require("@jobmatchme/tracking/es/provider/Tracking"));

var _External = _interopRequireWildcard(require("@jobmatchme/routing/es/provider/External"));

var _getConfig = _interopRequireDefault(require("@jobmatchme/profile-components/es/resources/getConfig"));

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

var _index = _interopRequireDefault(require("@jobmatchme/ui/es/components/icons/Close/index"));

var _Pc = _interopRequireDefault(require("@jobmatchme/amplify-tools/es/provider/Pc"));

var _getUrlParam = require("@jobmatchme/utils/es/getUrlParam");

var _lazy = require("@jobmatchme/library-utils/es/lazy");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _packageVersions = _interopRequireDefault(require("../packageVersions.json"));

var _notistack = require("notistack");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//import {useAbTest} from '@jobmatchme/utils/es/ABTest'
//import {FUNNEL_ABTEST_NAME} from '@jobmatchme/utils/es/funnelAbTest'
var FunnelLogistics = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'funnelLogistics' */
  './FunnelLogistics');
});
var FunnelAll = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'funnelAll' */
  './FunnelAll');
});
var FunnelGeneric = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'funnelGeneric' */
  './FunnelGeneric');
});
var RegistrationDefined = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'registrationDefined' */
  './RegistrationDefined');
});
var RegistrationInverse = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'registrationInverse' */
  './RegistrationInverse');
});
var RegistrationSocial = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'registrationSocial' */
  './RegistrationSocial');
});
var NotFoundPage = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'notFoundPage' */
  '@jobmatchme/landing-page-components/es/components/truck/common/NotFoundPage');
});
var MatchesApp = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'matchesApp' */
  '@jobmatchme/pc-matching/es/components/App');
});
var PageOptIn = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'optIn' */
  '@jobmatchme/pc-matching/es/components/Pages/OptIn');
});
var PageResetPassword = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'pageResetPwd' */
  '@jobmatchme/pc-matching/es/components/Pages/ResetPassword');
});
var PageForgotPassword = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'pageForgottPwd' */
  '@jobmatchme/pc-matching/es/components/Pages/ForgotPassword');
});
var PageLogin = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'pageLogin' */
  '@jobmatchme/pc-matching/es/components/Pages/Login');
});
var OptoutSettings = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'optoutSettings' */
  '@jobmatchme/pc-matching/es/components/OptoutSettings');
});
var Dashboard = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'dashboardApp' */
  '@jobmatchme/bc-dashboard/es/components/App');
});

var RoutedApp = function RoutedApp(_ref) {
  var router = _ref.router,
      location = _ref.location;

  // activate ABTest
  // useAbTest(FUNNEL_ABTEST_NAME)
  var pcFunnelRoute = function pcFunnelRoute(discriminator) {
    var vertical = (0, _getConfig.default)(discriminator)('pc').vertical;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
      exact: true,
      id: 'pcfunnel' + discriminator,
      path: {
        de: '/jobs/' + vertical.de + '/suche/*',
        at: '/jobs/' + vertical.at + '/suche/*',
        pl: '/jobs/' + vertical.pl + '/szukaj-pracy/*',
        en: '/employee/' + vertical.en + '/jobsearch/*'
      },
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelGeneric, {
        discriminator: discriminator
      })
    });
  };

  var pcSimplifiedRegFormRoute = function pcSimplifiedRegFormRoute(discriminator) {
    var vertical = (0, _getConfig.default)(discriminator)('pc').vertical;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
      exact: true,
      id: 'pcSimplifiedRegFormRoute' + discriminator,
      path: {
        de: '/jobs/' + vertical.de + '/bewerben/*',
        at: '/jobs/' + vertical.at + '/bewerben/*',
        pl: '/jobs/' + vertical.pl + '/zastosowac/*',
        en: '/employee/' + vertical.en + '/application/*'
      },
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(RegistrationInverse, {
        discriminator: discriminator
      })
    });
  };

  var pcRegistrationRoute = function pcRegistrationRoute(discriminator) {
    var vertical = (0, _getConfig.default)(discriminator)('pc').vertical;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
      exact: true,
      id: 'pcreg' + discriminator,
      path: {
        de: '/jobs/' + vertical.de + '/suche/registrierung/*',
        at: '/jobs/' + vertical.at + '/suche/registrierung/*',
        pl: '/jobs/' + vertical.pl + '/szukaj-pracy/rejestracja/*',
        en: '/jobs/' + vertical.en + '/jobsearch/registration/*'
      },
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(RegistrationDefined, {
        discriminator: discriminator,
        variant: 'pc'
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.default.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {
      fullPage: true
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_External.default, {
      no404: true,
      locale: (0, _getUrlParam.getUrlLocale)(typeof window !== 'undefined' ? window.location.pathname : location),
      notFoundPage: NotFoundPage,
      packageVersions: _packageVersions.default,
      router: router,
      location: location,
      children: [pcFunnelRoute('care'), pcFunnelRoute('truck'), pcFunnelRoute('logistics-scheduler'), pcFunnelRoute('service-gastro'), pcRegistrationRoute('care'), pcRegistrationRoute('truck'), pcRegistrationRoute('logistics-scheduler'), pcRegistrationRoute('service-gastro'), pcSimplifiedRegFormRoute('care'), pcSimplifiedRegFormRoute('truck'), pcSimplifiedRegFormRoute('logistics-scheduler'), pcSimplifiedRegFormRoute('service-gastro'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        exact: true,
        id: "pcfunnelLogistics",
        path: {
          de: '/jobs/logistik/suche/*',
          pl: '/jobs/logistyka/szukaj-pracy/*',
          at: '/jobs/logistik/suche/*',
          en: '/jobs/logistics/search/*'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelLogistics, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        exact: true,
        id: "pcfunnelAll",
        path: {
          de: '/jobs/all/suche/*',
          pl: '/jobs/all/szukaj-pracy/*',
          at: '/jobs/all/suche/*',
          en: '/jobs/all/search/*'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelAll, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        exact: true,
        id: 'pcreg',
        path: {
          de: '/jobs/suche/registrierung/',
          pl: '/jobs/szukaj-pracy/rejestracja/',
          at: '/jobs/suche/registrierung/',
          en: '/jobs/jobsearch/registration/'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(RegistrationSocial, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        exact: true,
        id: 'pcLogin',
        path: {
          de: '/login/',
          pl: '/login/',
          at: '/login/',
          en: '/login/'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(PageLogin, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        exact: true,
        id: 'pcforgotpwd',
        path: {
          de: '/jobs/suche/forgot-password/',
          pl: '/jobs/szukaj-pracy/forgot-password/',
          at: '/jobs/suche/forgot-password/',
          en: '/employee/jobsearch/forgot-password/'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(PageForgotPassword, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        exact: true,
        id: 'pcresetpwd',
        path: {
          de: '/jobs/suche/reset-password/:code/:email',
          pl: '/jobs/szukaj-pracy/reset-password/:code/:email',
          at: '/jobs/suche/reset-password/:code/:email',
          en: '/employee/jobsearch/reset-password/:code/:email'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(PageResetPassword, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: "pcoptin",
        path: {
          de: '/verify/:code/',
          pl: '/verify/:code/',
          at: '/verify/:code/'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(PageOptIn, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: "pcoptout",
        path: {
          de: '/optout/',
          pl: '/optout/',
          at: '/optout/'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(PageOptIn, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: "pcOptoutSettings",
        path: {
          de: '/arbeitnehmer/app/optoutSettings/:token/',
          pl: '/pracownik/app/optoutSettings/:token/',
          at: '/arbeitnehmer/app/optoutSettings/:token/'
        },
        children: function children(_ref2) {
          var _ref2$match = _ref2.match;
          _ref2$match = _ref2$match === void 0 ? {} : _ref2$match;
          var _ref2$match$params = _ref2$match.params;
          _ref2$match$params = _ref2$match$params === void 0 ? {} : _ref2$match$params;
          var _ref2$match$params$to = _ref2$match$params.token,
              token = _ref2$match$params$to === void 0 ? undefined : _ref2$match$params$to;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(PageOptIn, {
            token: token
          });
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: "pcOptoutSettingsNoToken",
        path: {
          de: '/arbeitnehmer/app/optoutSettings/',
          pl: '/pracownik/app/optoutSettings/',
          at: '/arbeitnehmer/app/optoutSettings/'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(OptoutSettings, {
          token: "logedin"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: 'pcmatching',
        path: {
          de: '/arbeitnehmer/app/*',
          pl: '/pracownik/app/*',
          at: '/arbeitnehmer/app/*',
          en: '/employee/app/*'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(MatchesApp, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: "dashboard",
        path: {
          de: '/arbeitgeber/app/*',
          pl: '/pracodawca/app/*',
          at: '/arbeitgeber/app/*'
        },
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(Dashboard, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: "bcPage",
        path: {
          de: '/arbeitgeber/',
          pl: '/pracodawca/',
          at: '/arbeitgeber/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        staticPath: true,
        id: 'home',
        host: "https://jobmatch.me",
        path: {
          de: '/',
          pl: '/',
          at: '/',
          en: '/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: 'lpImprint',
        path: {
          de: '/impressum/',
          pl: '/odcisk/',
          at: '/impressum/',
          en: '/imprint/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: 'lpTerms',
        path: {
          de: '/nutzungsbedingungen/',
          pl: '/warunkikorzystania/',
          at: '/nutzungsbedingungen/',
          en: '/terms/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        id: 'lpPrivacy',
        path: {
          de: '/datenschutz/',
          pl: '/politykaprywatnosci/',
          at: '/datenschutz/',
          en: '/privacy/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        staticPath: true,
        id: 'pcmatchinghome',
        path: {
          de: '/arbeitnehmer/app/home/',
          pl: '/pracownik/app/home/',
          at: '/arbeitnehmer/app/home/',
          en: '/employee/app/home/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        staticPath: true,
        id: 'pcmatchinglikedirect',
        path: {
          de: '/arbeitnehmer/app/like/',
          pl: '/pracownik/app/like/',
          at: '/arbeitnehmer/app/like/',
          en: '/employee/app/like/'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
        staticPath: true,
        id: 'pcregistration',
        path: {
          de: '/fahrer/jobsuche/registrierung/',
          at: '/fahrer/jobsuche/registrierung/',
          pl: '/kierowca/szukaj-pracy/rejestracja/'
        }
      })]
    })
  });
};

var App = function App(_ref3) {
  var router = _ref3.router,
      location = _ref3.location;

  var notistackRef = /*#__PURE__*/_react.default.createRef();

  var onClickDismiss = function onClickDismiss(key) {
    return function () {
      notistackRef.current.closeSnackbar(key);
    };
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {
      fullPage: true
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pc.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_notistack.SnackbarProvider, {
        maxSnack: 5,
        ref: notistackRef,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        action: function action(key) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
            "aria-label": "Close",
            color: "inherit",
            onClick: onClickDismiss(key),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default, {
              color: "white"
            })
          }, "close");
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tracking.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RoutedApp, {
            router: router,
            location: location
          })
        })
      })
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(App);

exports.default = _default;